<script>
	// NPM Modules
	import { navigate } from 'svelte-navaid';
	// Stores
	import RoleStore from '@/Stores/RoleStore.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import Helmet from '@/Components/Helmet.svelte';
	import Icon from '@/Components/Icon.svelte';

	let loading = getRoles();

	function getRoles() {
		return RoleStore.getRoles();
	}

	function click(id) {
		navigate(`/roles/${id}`);
	}
</script>

<Helmet title="Roles" />

<div>
	{#await loading}
		<Loading />
	{:then}
		<div>
			<!-- Page Header -->
			<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
				<div class="flex items-center w-full">
					<h1 class="text-xl font-bold">Roles</h1>
				</div>
			</div>
			<!-- /Page Header -->
			<div class="p-2 mx-4 bg-gray-100 rounded">
				<div class="overflow-x-auto rounded">
					<table class="w-full whitespace-nowrap">
						<thead>
							<tr class="text-xs text-left text-gray-500 uppercase">
								<th class="px-6 pt-5 pb-4 font-medium">Description</th>
								<th class="px-6 pt-5 pb-4 font-medium" />
							</tr>
						</thead>
						<tbody class="bg-white">
							{#each $RoleStore.all() as role (role.id)}
								<tr on:click={() => click(role.id)} class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100">
									<td class="p-4 px-6 font-semibold border-t">{role.name}</td>
									<td class="w-px px-6 border-t">
										<Icon name="chevron-right" classes="block w-4 h-4 text-gray-400 inline" />
									</td>
								</tr>
							{:else}
								<tr>
									<td class="px-6 py-4 text-center border-t" colspan="2"> No roles found. </td>
								</tr>
							{/each}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	{/await}
</div>
